import * as memoize from "memoizee";
import { StorageManager } from "@root/lib/utils/storage-manager";
import { userStore } from "@root/stores/user-store";
import { locationStore } from "@root/stores/location-store";

// Expose a 'memoized' function to get a storage manager for the current beacon.
const memoizedGetStorageManager = memoize((userId: string, beaconName: string) => new StorageManager(userId, beaconName));
export const getStorageManager = () => memoizedGetStorageManager(userStore.currentUser.id, locationStore.beacon);
